import { Checkbox } from "@/components/ui/checkbox";

interface CheckoutFormProps {
  form: { firstName: string; lastName: string; email: string; phone: string; address: string; city: string; zip: string };
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  emailError: string;
  onEmailChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  saveInfo: boolean;
  onSaveInfoChange: (checked: boolean) => void;
  isPickup: boolean;
}

const inputClass =
  "w-full bg-white border border-border rounded-xl px-4 py-3 text-sm text-foreground focus:border-foreground focus:ring-2 focus:ring-foreground/10 outline-none transition-colors";

export default function CheckoutForm({
  form,
  onChange,
  emailError,
  onEmailChange,
  saveInfo,
  onSaveInfoChange,
  isPickup,
}: CheckoutFormProps) {
  return (
    <>
      <section>
        <h2 className="text-[11px] font-semibold uppercase tracking-[0.15em] text-muted-foreground mb-6">
          Kontakt
        </h2>
        <div>
          <label className="text-[11px] text-muted-foreground/70 block mb-1">Email</label>
          <input
            name="email"
            type="email"
            value={form.email}
            onChange={(e) => {
              onEmailChange(e);
            }}
            required
            className={`${inputClass} ${emailError ? "border-red-400 focus:border-red-400" : ""}`}
            placeholder="vas@email.ba"
          />
          {emailError && (
            <p className="text-xs text-red-500 mt-1.5">{emailError}</p>
          )}
        </div>
      </section>

      <section>
        <h2 className="text-[11px] font-semibold uppercase tracking-[0.15em] text-muted-foreground mb-6">
          Podaci za dostavu
        </h2>
        <div className="space-y-1">
          <div className="grid grid-cols-2 gap-6">
            <div>
              <label className="text-[11px] text-muted-foreground/70 block mb-1">Ime</label>
              <input
                name="firstName"
                value={form.firstName}
                onChange={onChange}
                required
                className={inputClass}
                placeholder="Vaše ime"
              />
            </div>
            <div>
              <label className="text-[11px] text-muted-foreground/70 block mb-1">Prezime</label>
              <input
                name="lastName"
                value={form.lastName}
                onChange={onChange}
                required
                className={inputClass}
                placeholder="Vaše prezime"
              />
            </div>
          </div>

          <div>
            <label className="text-[11px] text-muted-foreground/70 block mb-1 mt-5">Telefon</label>
            <input
              name="phone"
              value={form.phone}
              onChange={onChange}
              required
              className={inputClass}
              placeholder="061 234 567"
            />
          </div>

          {isPickup ? (
            <div className="rounded-xl bg-muted/40 border border-border/60 px-4 py-3 text-xs text-muted-foreground">
              Lično preuzimanje na području Općine Tešanj — adresa dostave nije potrebna.
            </div>
          ) : (
            <>
              <div>
                <label className="text-[11px] text-muted-foreground/70 block mb-1 mt-5">Adresa</label>
                <input
                  name="address"
                  value={form.address}
                  onChange={onChange}
                  required
                  className={inputClass}
                  placeholder="Ulica i broj"
                />
              </div>

              <div className="grid grid-cols-2 gap-6">
                <div>
                  <label className="text-[11px] text-muted-foreground/70 block mb-1 mt-5">Grad</label>
                  <input
                    name="city"
                    value={form.city}
                    onChange={onChange}
                    required
                    className={inputClass}
                    placeholder="Sarajevo, Mostar..."
                  />
                </div>
                <div>
                  <label className="text-[11px] text-muted-foreground/70 block mb-1 mt-5">Poštanski broj</label>
                  <input
                    name="zip"
                    value={form.zip}
                    onChange={onChange}
                    required
                    className={inputClass}
                    placeholder="71000, 88000..."
                  />
                </div>
              </div>
            </>
          )}
        </div>

        <label className="flex items-center gap-2.5 mt-6 cursor-pointer group">
          <Checkbox
            checked={saveInfo}
            onCheckedChange={(c) => onSaveInfoChange(c === true)}
            className="border-border/60"
          />
          <span className="text-xs text-muted-foreground group-hover:text-foreground/70 transition-colors">
            Zapamti podatke za sljedeću kupovinu
          </span>
        </label>
      </section>
    </>
  );
}
